import React, { useEffect, useRef } from "react";
import "./StateSection.css";

const statsData = [
  { value: "१८+", label: "वर्षांचा अनुभव" },
  { value: "१०,०००+", label: "पुस्तकांचा संग्रह" },
  { value: "१,५००+", label: "ग्रंथालय सभासद" },
  { value: "१९५०+", label: "क्षेत्रफळ (चौ. फूट)" },
];

const StatsSection = () => {
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("animate");
        }
      },
      { threshold: 0.3 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  return (
    <section className="stats-section" ref={sectionRef}>
      <div className="stats-container">
        {statsData.map((item, index) => (
          <div className="stat-card" key={index}>
            <div className="stat-value">{item.value}</div>
            <div className="stat-label">{item.label}</div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default StatsSection;
